module.exports = __webpack_public_path__ + "img/man_1_4.358d4724.png";